import { render, staticRenderFns } from "./TalentRow.vue?vue&type=template&id=19adf577&scoped=true&"
import script from "./TalentRow.vue?vue&type=script&lang=js&"
export * from "./TalentRow.vue?vue&type=script&lang=js&"
import style0 from "./TalentRow.vue?vue&type=style&index=0&id=19adf577&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19adf577",
  null
  
)

export default component.exports